import { readCookie } from '../cookies';
export var XSRF_TOKEN_COOKIE_NAME = 'XSRF-TOKEN';
export var XSRF_HEADER_NAME = 'x-xsrf-token';
export function csrf() {
    var _a;
    var value = readCookie(XSRF_TOKEN_COOKIE_NAME);
    return _a = {}, _a[XSRF_HEADER_NAME] = value, _a;
}
//# sourceMappingURL=csrf.js.map